import { render, staticRenderFns } from "./SectionPreviewLink.vue?vue&type=template&id=56b7076e&"
import script from "./SectionPreviewLink.vue?vue&type=script&lang=ts&"
export * from "./SectionPreviewLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports